export const DYNAMIC_PASSWORD = 10;       //动态密码
export const DYNAMIC_TOKEN = 20;        //动态令牌
export const SECOND_AUTH_PASSWORD = 30;     //二次验证密码
export const CA_AUTH = 40;        //CA验证
export const QYS = 50;       //契约锁
export const REAL_ID_AUTH = 60;       //真实身份认证

export const SECOND_AUTH_DIALOG = "secondAuthDialog";     //二次验证的窗口
export const AUTH_DETAIL_DIALOG = "authDetailDialog";     //篡改详情的窗口


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/constants/secondAuthType.js